<template>
  <div class="knowlegdebank-list">
    <div class="grid-container">
      <div class="knowlegdebank-list__actions">
        <div @click="orderByDate()" class="knowlegdebank-list__actions-sort">
          <svg
              v-if="!sortedByDate"
              width="24"
              height="18"
              viewBox="0 0 24 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M10.6375 16.1251C10.6375 16.3793 10.5365 16.623 10.3568 16.8027C10.1771 16.9825 9.93333 17.0834 9.67917 17.0834H0.958333C0.704167 17.0834 0.460412 16.9825 0.280689 16.8027C0.100967 16.623 0 16.3793 0 16.1251C0 15.8709 0.100967 15.6272 0.280689 15.4475C0.460412 15.2677 0.704167 15.1668 0.958333 15.1668H9.67917C9.93333 15.1668 10.1771 15.2677 10.3568 15.4475C10.5365 15.6272 10.6375 15.8709 10.6375 16.1251ZM11.5958 7.88343H0.958333C0.704167 7.88343 0.460412 7.9844 0.280689 8.16412C0.100967 8.34384 0 8.5876 0 8.84177C0 9.09593 0.100967 9.33969 0.280689 9.51941C0.460412 9.69913 0.704167 9.8001 0.958333 9.8001H11.5958C11.85 9.8001 12.0938 9.69913 12.2735 9.51941C12.4532 9.33969 12.5542 9.09593 12.5542 8.84177C12.5542 8.5876 12.4532 8.34384 12.2735 8.16412C12.0938 7.9844 11.85 7.88343 11.5958 7.88343ZM21.8596 12.5697C21.7705 12.4799 21.6645 12.4086 21.5477 12.3599C21.4309 12.3113 21.3057 12.2862 21.1792 12.2862C21.0527 12.2862 20.9274 12.3113 20.8106 12.3599C20.6938 12.4086 20.5878 12.4799 20.4988 12.5697L19.2625 13.8155V1.55843C19.2625 1.30427 19.1615 1.06051 18.9818 0.880787C18.8021 0.701065 18.5583 0.600098 18.3042 0.600098C18.05 0.600098 17.8062 0.701065 17.6265 0.880787C17.4468 1.06051 17.3458 1.30427 17.3458 1.55843V13.8155L16.1096 12.5697C16.0202 12.4803 15.9142 12.4095 15.7974 12.3611C15.6807 12.3127 15.5555 12.2878 15.4292 12.2878C15.3028 12.2878 15.1777 12.3127 15.0609 12.3611C14.9442 12.4095 14.8381 12.4803 14.7488 12.5697C14.6594 12.659 14.5885 12.7651 14.5402 12.8819C14.4918 12.9986 14.4669 13.1237 14.4669 13.2501C14.4669 13.3765 14.4918 13.5016 14.5402 13.6183C14.5885 13.7351 14.6594 13.8412 14.7488 13.9305L17.6238 16.8055C17.7128 16.8953 17.8188 16.9666 17.9356 17.0153C18.0524 17.0639 18.1777 17.089 18.3042 17.089C18.4307 17.089 18.5559 17.0639 18.6727 17.0153C18.7895 16.9666 18.8955 16.8953 18.9846 16.8055L21.8596 13.9305C21.9494 13.8414 22.0207 13.7354 22.0694 13.6187C22.118 13.5019 22.1431 13.3766 22.1431 13.2501C22.1431 13.1236 22.118 12.9983 22.0694 12.8815C22.0207 12.7648 21.9494 12.6588 21.8596 12.5697ZM13.5125 0.600098H0.958333C0.704167 0.600098 0.460412 0.701065 0.280689 0.880787C0.100967 1.06051 0 1.30427 0 1.55843C0 1.8126 0.100967 2.05635 0.280689 2.23608C0.460412 2.4158 0.704167 2.51676 0.958333 2.51676H13.5125C13.7667 2.51676 14.0104 2.4158 14.1901 2.23608C14.3699 2.05635 14.4708 1.8126 14.4708 1.55843C14.4708 1.30427 14.3699 1.06051 14.1901 0.880787C14.0104 0.701065 13.7667 0.600098 13.5125 0.600098Z"
                fill="#2C0313"
            />
          </svg>
          <svg
              v-else
              width="24"
              height="18"
              viewBox="0 0 24 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M10.6375 1.55867C10.6375 1.81284 10.5365 2.0566 10.3568 2.23632C10.1771 2.41604 9.93333 2.51701 9.67917 2.51701H0.958333C0.704167 2.51701 0.460412 2.41604 0.280689 2.23632C0.100967 2.0566 0 1.81284 0 1.55867C0 1.30451 0.100967 1.06075 0.280689 0.881029C0.460412 0.701307 0.704167 0.600342 0.958333 0.600342H9.67917C9.93333 0.600342 10.1771 0.701307 10.3568 0.881029C10.5365 1.06075 10.6375 1.30451 10.6375 1.55867Z"
                fill="#2C0313"
            />
            <path
                d="M10.6375 1.55867C10.6375 1.81284 10.5365 2.0566 10.3568 2.23632C10.1771 2.41604 9.93333 2.51701 9.67917 2.51701H0.958333C0.704167 2.51701 0.460412 2.41604 0.280689 2.23632C0.100967 2.0566 0 1.81284 0 1.55867C0 1.30451 0.100967 1.06075 0.280689 0.881029C0.460412 0.701307 0.704167 0.600342 0.958333 0.600342H9.67917C9.93333 0.600342 10.1771 0.701307 10.3568 0.881029C10.5365 1.06075 10.6375 1.30451 10.6375 1.55867Z"
                fill="#2C0313"
            />
            <path
                d="M0.958333 7.88354H11.5958C11.85 7.88354 12.0938 7.98451 12.2735 8.16423C12.4532 8.34396 12.5542 8.58771 12.5542 8.84188C12.5542 9.09604 12.4532 9.3398 12.2735 9.51952C12.0938 9.69924 11.85 9.80021 11.5958 9.80021H0.958333C0.704167 9.80021 0.460412 9.69924 0.280689 9.51952C0.100967 9.3398 0 9.09604 0 8.84188C0 8.58771 0.100967 8.34396 0.280689 8.16423C0.460412 7.98451 0.704167 7.88354 0.958333 7.88354Z"
                fill="#2C0313"
            />
            <path
                d="M0.958333 15.1702H13.5125C13.7667 15.1702 14.0104 15.2711 14.1901 15.4509C14.3699 15.6306 14.4708 15.8743 14.4708 16.1285C14.4708 16.3827 14.3699 16.6264 14.1901 16.8061C14.0104 16.9859 13.7667 17.0868 13.5125 17.0868H0.958333C0.704167 17.0868 0.460412 16.9859 0.280689 16.8061C0.100967 16.6264 0 16.3827 0 16.1285C0 15.8743 0.100967 15.6306 0.280689 15.4509C0.460412 15.2711 0.704167 15.1702 0.958333 15.1702Z"
                fill="#2C0313"
            />
            <path
                d="M16.2836 5.11952C16.3727 5.20935 16.4787 5.28064 16.5955 5.3293C16.7122 5.37795 16.8375 5.403 16.964 5.403C17.0905 5.403 17.2158 5.37795 17.3326 5.3293C17.4493 5.28064 17.5553 5.20935 17.6444 5.11952L18.8807 3.87369V16.1308C18.8807 16.3849 18.9816 16.6287 19.1614 16.8084C19.3411 16.9881 19.5849 17.0891 19.839 17.0891C20.0932 17.0891 20.3369 16.9881 20.5167 16.8084C20.6964 16.6287 20.7973 16.3849 20.7973 16.1308V3.87369L22.0336 5.11952C22.123 5.20888 22.229 5.27976 22.3458 5.32812C22.4625 5.37647 22.5877 5.40136 22.714 5.40136C22.8404 5.40136 22.9655 5.37647 23.0823 5.32812C23.199 5.27976 23.3051 5.20888 23.3944 5.11952C23.4838 5.03017 23.5547 4.92409 23.603 4.80735C23.6514 4.6906 23.6763 4.56547 23.6763 4.43911C23.6763 4.31274 23.6514 4.18762 23.603 4.07087C23.5547 3.95413 23.4838 3.84805 23.3944 3.75869L20.5194 0.883692C20.4303 0.793869 20.3243 0.722573 20.2076 0.67392C20.0908 0.625266 19.9655 0.600218 19.839 0.600218C19.7125 0.600218 19.5872 0.625266 19.4705 0.67392C19.3537 0.722573 19.2477 0.793869 19.1586 0.883692L16.2836 3.75869C16.1938 3.84778 16.1225 3.95377 16.0738 4.07056C16.0252 4.18734 16.0001 4.3126 16.0001 4.43911C16.0001 4.56562 16.0252 4.69088 16.0738 4.80766C16.1225 4.92444 16.1938 5.03043 16.2836 5.11952Z"
                fill="#2C0313"
            />
          </svg>

          <span>Sorter på dato</span>
        </div>
      </div>
      <div v-if="currentPageData.length === 0">Intet indhold</div>
      <ul class="knowlegdebank-list__items" v-else>
        <li
            v-for="item in currentPageData"
            :key="item.id"
            class="knowlegdebank-list__item"
            :class="{ active: item.id === selectedId }"
        >
          <div class="knowlegdebank-list__item-wrapper">
            <div class="knowlegdebank-list__item-info">
              <div class="knowlegdebank-list__meta">
                <p v-if="item.date">{{ toDate(item.date) }}</p>
                <p v-if="item.type">{{ item.type }}</p>
                <p v-if="item.number">Sags.nr : {{ item.number }}</p>
              </div>
              <div class="knowlegdebank-list__cta">
                <a :href="item.url">
                  <p class="knowlegdebank-list__item-title">{{ item.title }}</p>
                </a>
              </div>
            </div>
            <div
                class="knowlegdebank-list__cta-summary"
                :class="{ active: item.id === selectedId }"
                @click="findSelectedById(item.id)"
            >
              <svg
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M13.5159 0H0.961751C0.707585 0 0.46383 0.100967 0.284107 0.280689C0.104385 0.460412 0.00341797 0.704168 0.00341797 0.958333C0.00341797 1.2125 0.104385 1.45626 0.284107 1.63598C0.46383 1.8157 0.707585 1.91667 0.961751 1.91667H13.5159C13.7701 1.91667 14.0138 1.8157 14.1936 1.63598C14.3733 1.45626 14.4742 1.2125 14.4742 0.958333C14.4742 0.704168 14.3733 0.460412 14.1936 0.280689C14.0138 0.100967 13.7701 0 13.5159 0Z"
                    fill="#000"
                />
                <path
                    d="M13.5159 6H0.961751C0.707585 6 0.46383 6.10097 0.284107 6.28069C0.104385 6.46041 0.00341797 6.70417 0.00341797 6.95833C0.00341797 7.2125 0.104385 7.45626 0.284107 7.63598C0.46383 7.8157 0.707585 7.91667 0.961751 7.91667H13.5159C13.7701 7.91667 14.0138 7.8157 14.1936 7.63598C14.3733 7.45626 14.4742 7.2125 14.4742 6.95833C14.4742 6.70417 14.3733 6.46041 14.1936 6.28069C14.0138 6.10097 13.7701 6 13.5159 6Z"
                    fill="#000"
                />
                <path
                    d="M13.5125 12.0833H0.958333C0.704167 12.0833 0.460412 12.1843 0.280689 12.364C0.100967 12.5437 0 12.7875 0 13.0417C0 13.2958 0.100967 13.5396 0.280689 13.7193C0.460412 13.899 0.704167 14 0.958333 14H13.5125C13.7667 14 14.0104 13.899 14.1901 13.7193C14.3699 13.5396 14.4708 13.2958 14.4708 13.0417C14.4708 12.7875 14.3699 12.5437 14.1901 12.364C14.0104 12.1843 13.7667 12.0833 13.5125 12.0833Z"
                    fill="#000"
                />
              </svg>

              <span>
              Vis sagsresumé
            </span>
            </div>
          </div>
          <div
              class="knowlegdebank-list__item-summary"
              v-if="item.id === selectedId"
          >
            <div class="knowlegdebank-list__cta-summary-title">
              SAGSRESUMÉ
            </div>
            {{ item.summary }}
          </div>
        </li>
      </ul>
    </div>
    <Pagination
        v-on:nextPage="nextPage($event)"
        v-on:goToPage="goToPage($event)"
        v-on:previousPage="previousPage($event)"
        :itemsPerPage="itemsPerPage"
        :currentPage="currentPage"
        :pageAmount="pageAmount"
    ></Pagination>
  </div>
</template>

<script>
import FilterComponent from "../shared/Filters.vue";
import Pagination from "../shared/ListPagination.vue";

export default {
  props: ["articleItems"],
  components: {
    FilterComponent,
    Pagination,
  },
  data() {
    return {
      items: JSON.parse(this.articleItems),
      filterBy: {article: false, warrant: false, judgement: false},
      isOpen: false,
      sortedByDate: false,
      loading: true,
      isPaginate: true,
      itemsPerPage: 10,
      currentPage: 1,
      numPages: 0,
      selectedId: null,
    };
  },
  computed: {
    pageAmount() {
      return Math.ceil(this.items.length / this.itemsPerPage);
    },
    currentPageData() {
      let rawArticles = JSON.parse(this.articleItems);

      if (this.sortedByDate) {
        rawArticles.sort(function (a, b) {
          let dateA = new Date(a.date);
          let dateB = new Date(b.date);

          return dateA - dateB;
        });
      }

      let startIndex = (this.currentPage - 1) * this.itemsPerPage;
      let endIndex = startIndex + this.itemsPerPage;
      return rawArticles.splice(startIndex, endIndex);
    },
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    scrollTo() {
      window.scrollTo({
        top: 10,
        behavior: "smooth",
      });
    },
    goToPage(number) {
      this.currentPage = number;
      this.scrollTo();
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.scrollTo();
      }
    },
    nextPage() {
      if (this.currentPage < Math.ceil(this.items.length / this.itemsPerPage)) {
        this.currentPage++;
        this.scrollTo();
      }
    },
    toDate(date) {
      let curDate = new Date(date).toLocaleString('da-DK', {
        weekday: 'short',
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      let splitArr = curDate.split(" ");
      let rawMonth = splitArr[2].substring(0, 3);
      const firstLetter = rawMonth.charAt(0).toLocaleUpperCase();
      let month = firstLetter + rawMonth.slice(1)
      return `${splitArr[1]} ${month} ${splitArr[3]}`;
    },
    orderByDate() {
      if (this.sortedByDate) {
        this.currentPageData.sort(function (a, b) {
          let dateA = new Date(a.date);
          let dateB = new Date(b.date);

          return dateB - dateA;
        });
        this.sortedByDate = false;
      } else {
        this.currentPageData.sort(function (a, b) {
          let dateA = new Date(a.date);
          let dateB = new Date(b.date);
          return dateA - dateB;
        });
        this.sortedByDate = true;
      }
    },
    findSelectedById(id) {
      if (id === this.selectedId) {
        return (this.selectedId = null);
      }
      this.selectedId = id;
    },
  },
};
</script>
